/* ==========================================================
   uhren4you – Usability, Runde 1 (31.10.2026)
   Geladen nach assets/u4y-site.js (layout/theme.liquid), auf jeder Seite.
   1. Produktseite: Ein Reiter öffnet seinen zugeklappten Abschnitt („Versand & Rückgabe“).
   2. Warenkorb auf dem Handy: feste Leiste mit Summe und „Zur Kasse“, solange der echte Button nicht im Bild ist.
   3. Produktkarten: Titel nur bis zum ersten „ • “ (Marke, Modell, Typ); der volle Titel steht im Tooltip.
   4. Kategorieseiten: „Mehr lesen“ klappt den gekürzten Text oben auf und wieder zu.
   5. Suche im Kopf: Es erscheint nur die Suche der Filter-App (Globo), nicht zusätzlich das Such-Fenster des Themes.
   Usability, Runde 2 (31.10.2026):
   6. Markengeschichte: allgemeine Zeile „Sorgenfrei & sicher Einkaufen“ ausblenden; auf der Produktseite
      auf dem Handy zum aufklappbaren Abschnitt machen (Styles: assets/u4y-ux.css).
   ========================================================== */
(function () {
  'use strict';

  /* ---------- 1. Reiter öffnet zugeklappte Abschnitte ---------- */
  function openSection(id) {
    var sec = id ? document.getElementById(id) : null;
    var det = sec ? sec.querySelector('details') : null;
    if (det && !det.open) det.open = true;
  }
  function bindTabs() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.u4y-pd__tab') : null;
      if (!a) return;
      openSection((a.getAttribute('href') || '').replace('#', ''));
    });
    if (location.hash && location.hash.indexOf('#u4y-pd-') === 0) openSection(location.hash.slice(1));
  }

  /* ---------- 2. Warenkorb: feste Leiste auf dem Handy ---------- */
  function cartBar() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var bar = document.createElement('div');
    bar.className = 'u4y-cartbar';
    bar.innerHTML =
      '<div class="u4y-cartbar__inner">' +
      '<div class="u4y-cartbar__sum"><span class="u4y-cartbar__label"></span><span class="u4y-cartbar__total"></span></div>' +
      '<button type="submit" form="cart" name="checkout" class="button button--primary u4y-cartbar__btn"></button>' +
      '</div>';
    document.body.appendChild(bar);
    var tick = false;
    function sync() {
      tick = false;
      var real = document.getElementById('checkout');
      var tot = footer.querySelector('.totals__total-value');
      var lab = footer.querySelector('.totals__total');
      var show = !!(real && tot && !real.disabled && mq.matches);
      if (show) {
        bar.querySelector('.u4y-cartbar__total').textContent = tot.textContent.replace(/\s+/g, ' ').trim();
        bar.querySelector('.u4y-cartbar__label').textContent = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
        bar.querySelector('.u4y-cartbar__btn').textContent = real.textContent.replace(/\s+/g, ' ').trim();
        var r = real.getBoundingClientRect();
        show = !(r.top < window.innerHeight && r.bottom > 0);
      }
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('u4y-cartbar-on', show);
    }
    function queue() {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(sync);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(footer, { childList: true, subtree: true, characterData: true });
    sync();
  }

  /* ---------- 3. Kurze Titel in Produktkarten ---------- */
  var CARD_TITLES = '.card__heading, .card__heading a, .spf-product-card__title, .spf-product-card__title a';
  function shortTitles() {
    var els = document.querySelectorAll(CARD_TITLES);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length || el.getAttribute('data-u4y-short')) continue;
      el.setAttribute('data-u4y-short', '1');
      var t = el.textContent;
      var k = t.indexOf(' • ');
      if (k > 0) {
        el.setAttribute('title', t.replace(/\s+/g, ' ').trim());
        el.textContent = t.slice(0, k).trim();
      }
    }
  }
  function watchTitles() {
    shortTitles();
    var waiting = false;
    new MutationObserver(function () {
      if (waiting) return;
      waiting = true;
      setTimeout(function () {
        waiting = false;
        shortTitles();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 4. Kategorieseiten: „Mehr lesen“ ---------- */
  function bindMore() {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.u4y-more') : null;
      if (!b) return;
      var box = b.closest('.u4y-colldesc');
      if (!box) return;
      var open = box.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = b.querySelector('.u4y-more__label');
      var txt = b.getAttribute(open ? 'data-less' : 'data-more');
      if (label && txt) label.textContent = txt;
    });
  }

  /* ---------- 5. Suche im Kopf ----------
     Die Lupe öffnet das Such-Fenster des Themes. Sobald dessen Eingabefeld den Fokus bekommt, öffnet die Filter-App
     (Globo, „Smart Product Filter & Search“) ihre eigene Suche über die ganze Breite. Das Fenster des Themes wird dann
     sofort geschlossen – sonst bliebe es nach dem Schließen der App-Suche dunkel im Hintergrund offen.
     Ohne die App bleibt alles wie gewohnt. */
  function headerSearch() {
    var dm = document.querySelector('.header__icons details-modal.header__search');
    var det = dm ? dm.querySelector('details') : null;
    if (!det || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (document.body.classList.contains('gl-search-open') && det.hasAttribute('open') && typeof dm.close === 'function') {
        dm.close(false);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 6. Markengeschichte ----------
     Die Seiten „…-brandstory“ haben zwei Zeilen: Marke + bei fast allen dieselbe zweite Zeile „Sorgenfrei & sicher
     Einkaufen“ (mit „13.000 Kunden“, in allen Sprachen). Nur diese allgemeine Zeile wird ausgeblendet – eigene zweite
     Zeilen (z. B. Lemnos, UMR Ruhla) bleiben. Auf der Produktseite (Abschnitt page_XmB3PQ) wird die Markengeschichte
     in ein <details> gelegt: auf dem Handy zugeklappt mit der Überschrift der Marke, am Computer immer offen. */
  var GENERIC_ROW = /13[.,\s]?000/; // \s umfasst auch geschützte Leerzeichen
  function brandStory() {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    Array.prototype.forEach.call(document.querySelectorAll('.brand-story-wrapper'), function (w) {
      Array.prototype.forEach.call(w.querySelectorAll('.bs-row.reverse'), function (r) {
        if (!GENERIC_ROW.test(r.textContent)) return;
        r.classList.add('u4y-bs-generic');
        var prev = r.previousElementSibling;
        if (prev && prev.classList.contains('bs-row')) prev.classList.add('u4y-bs-last');
      });
      if (!mq || !w.closest('[id$="__page_XmB3PQ"]') || w.closest('.u4y-brand')) return;
      var h = w.querySelector('.bs-row:not(.u4y-bs-generic) h2');
      if (!h) return;
      var det = document.createElement('details');
      det.className = 'u4y-brand u4y-pd__acc u4y-pd__acc--big';
      var sum = document.createElement('summary');
      var title = document.createElement('h2');
      title.className = 'u4y-pd__acc-h u4y-brand__title';
      title.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      var plus = document.createElement('span');
      plus.className = 'u4y-pd__plus';
      plus.setAttribute('aria-hidden', 'true');
      sum.appendChild(title);
      sum.appendChild(plus);
      h.classList.add('u4y-brand__h');
      w.parentNode.insertBefore(det, w);
      det.appendChild(sum);
      det.appendChild(w);
      function sync() {
        det.open = !mq.matches;
      }
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
    });
  }

  function init() {
    bindTabs();
    cartBar();
    watchTitles();
    bindMore();
    headerSearch();
    brandStory();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();